"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createVersionUpdater = void 0;
function updateOneVersionUpIfNeeded(configuration, updater, version) {
    if (configuration.version === version) {
        return updater(configuration);
    }
    return configuration;
}
function createVersionUpdater(configurationName, versionUpdateManagers) {
    return function (configuration) {
        let convertedConfiguration = configuration;
        for (let updateManagers of versionUpdateManagers) {
            convertedConfiguration = updateOneVersionUpIfNeeded(convertedConfiguration, updateManagers.updater, updateManagers.version);
        }
        if (convertedConfiguration.version === versionUpdateManagers[versionUpdateManagers.length - 1].version) {
            return convertedConfiguration;
        }
        throw new Error(`${configurationName} configuration version not supported (received version ${configuration.version} and got it up to ${convertedConfiguration.version})`);
    };
}
exports.createVersionUpdater = createVersionUpdater;
//# sourceMappingURL=utils.js.map